<template>
    <div class="row pb-3">
        <div class="col-11 col-sm-11">
            <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuemin="0" :aria-valuemax="max" :style="{'width' : percentage + '%'}" :class="color"></div>
            </div>
        </div>
        <div class="col-1 col-sm-1 text-white">
            <p  v-if="progress" class="stylingProgress float-right">{{progress | rand}}</p>
            <p  v-else class="stylingProgress float-right">0</p>
        </div>
        <br>
    </div>
    
</template>
<script>
export default {
    name: 'ProgressBar',
    props: {
        goal:{
            required: true,
        },
        progress: {
            required: true,
        }
    },
    data() {
        return {
            max: 0,
            p: 0,
        }
    },
    computed: {
        percentage(){
            this.max = this.goal * 6;
            this.p = (this.progress * 100) / this.max;
            return this.p;
        },
        color () {
			return{
				'green' : this.progress > this.goal,
                'blue' : this.progress == this.goal,
                'yellow' : this.progress < this.goal,
			}
		}
    },
    filters:{
        rand: (value) => {
            if (!value) return '';
            if (typeof value === 'number') {
                return value.toFixed(2);
            }
            return value;
        }
    }
}
</script>

<style scoped>
.yellow {
    background-color: #fbda67;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}
.green {
    background-color: #97da38;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}
.blue {
    background-color: #78d9ee;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}
.progress{
    border-radius: 10px;
    max-width: 95%;
    height: 20px;
    background-color: white;
}
</style>
